<template>
  <div>
    <div class="card-body">
      <selectlist
        name="type"
        placeholder="Please Letter Head"
        v-model="form.letter_head_id"
        label="Letter Head"
        :options="letterHeads"
        :required="true"
        :show-error="form.errors.has('letter_head_id')"
        :error-message="form.errors.get('letter_head_id')"
        key-name="id"
        v-if="letterHeads.length > 1"
      ></selectlist>

      <hire-mitigation-statement-form
        :incident="incident"
        :form="form"
        :document-types="documentTypes"
        v-if="!hire.mitigation_statement"
      ></hire-mitigation-statement-form>

      <div class="text-center" v-else>
        <button
          class="btn btn-primary"
          type="button"
          @click="downloadStatement"
        >
          Download Mitigation Statement
        </button>

        <div
          class="gutter-top"
          v-if="hasPermission('hires.regenerateDocuments')"
        >
          <p>
            To regenerate the mitigation statement
            <a class="cursor-pointer" @click="clearMitigationStatement"
              >click here.</a
            >
          </p>
        </div>
      </div>
    </div>

    <div
      class="card-footer text-right"
      v-if="!hire.mitigation_statement && !isReadonly()"
    >
      <form-button :indicator="indicator" v-on:clicked="generate">
        Generate
      </form-button>
    </div>
  </div>
</template>
<script>
import HireMitigationStatementForm from '@/components/Modules/Deployment/Children/Children/Children/HireMitigationStatementForm';

export default {
  props: {
    hire: {
      type: Object,
      required: true
    },
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    HireMitigationStatementForm
  },

  data() {
    return {
      form: new window.Form({
        letter_head_id: '',
        require_same_vehicle: false,
        additional_insurance_premium_required: false,
        license_less_than: '',
        tp_offered_services: false,
        reasons_hire_vehicle_is_required: '',
        non_standard_driver: false,
        non_standard_age: false,
        non_standard_occupation: false,
        non_standard_license_age: false,
        non_standard_convictions: false,
        travelling_to_and_from_work: false,
        distance_to_workplace: '',
        commute_frequency: '',
        shift_pattern: '',
        placeholders: []
      }),
      indicator: false
    };
  },

  computed: {
    documentTypes() {
      return this.$store.getters['DocumentTypes/all'] || [];
    },

    letterHeads() {
      return this.$store.getters['LetterHeads/all'] || [];
    }
  },

  mounted() {
    this.$store.commit('DocumentTypes/retrieve');
    this.$store.commit('LetterHeads/retrieve');
  },

  methods: {
    generate() {
      this.indicator = true;

      if (this.letterHeads.length === 1) {
        this.form.letter_head_id = this.letterHeads[0].id;
      }

      this.form
        .post(`/hires/${this.hire.identifier}/mitigation-statement`)
        .then(response => {
          this.hire.mitigation_statement = response;
          this.indicator = false;

          window.toastify.success(
            'Saved',
            "We've successfully generated the mitigation statement"
          );
        })
        .catch(err => {
          this.indicator = false;
          window.toastify.error(
            'Error',
            "Sorry, we couldn't generate the document. Please try again"
          );
        });
    },

    downloadStatement() {
      window.open(this.hire?.mitigation_statement?.url, '_blank');
    },

    clearMitigationStatement() {
      this.hire.mitigation_statement = null;
    }
  }
};
</script>
